// extracted by mini-css-extract-plugin
export default {"select":"SelectMaterial_select__KDQBs"};